
























































































































































import { Component } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import Alert from '@/components/Shared/Alert.vue';
import PageNames from '@/router/PageNames';
import PayrollRunDto from '@/models/Payroll/PayrollRunDto';
import PayrollPeriodInfoDto from '@/models/Payroll/PayrollPeriodInfoDto';
import { PayrollRunStatusLabels, PayrollRunStatusColors } from '@/models/Payroll/PayrollRunStatus';
import { PayrollRunListModule } from '@/store/modules/payrollRunList';

@Component({
    name: 'AgencyPayrollRuns',
    components: { Alert },
})
export default class extends GiganautVue {
    search = '';
    newRunDialog = false;

    headers = [
        { text: 'Period', value: 'periodEnd' },
        { text: 'Period reference', value: 'externalPayrollSystemPeriodId', width: 140 },
        { text: 'Status', value: 'status', width: 160 },
        { text: 'Workers', value: 'workersPushedCount', width: 90 },
        { text: 'Timesheets', value: 'timesheetsPushedCount', width: 140 },
        { text: 'Gross pay', value: 'totalGrossPay', width: 120 },
        { text: 'Updated', value: 'updatedAt', width: 160 },
        { text: '', value: 'actions', sortable: false, width: 60 },
    ];

    get loading(): boolean { return PayrollRunListModule.loading; }
    get runs(): PayrollRunDto[] { return PayrollRunListModule.runs; }
    get currentPeriod(): PayrollPeriodInfoDto | null { return PayrollRunListModule.currentPeriod; }
    get currentPeriodLoading(): boolean { return PayrollRunListModule.currentPeriodLoading; }
    get currentPeriodError(): string { return PayrollRunListModule.currentPeriodError; }

    // "Tax year 2026, month 4" style caption — provider-optional metadata,
    // hidden when the provider didn't supply it.
    get currentPeriodTaxLabel(): string {
        const p = this.currentPeriod;
        if (!p || !p.taxYear) return '';
        const parts = [`Tax year ${p.taxYear}`];
        if (p.taxMonth) parts.push(`month ${p.taxMonth}`);
        return parts.join(', ');
    }

    statusLabel(s: number): string { return PayrollRunStatusLabels[s] || String(s); }
    statusColor(s: number): string { return PayrollRunStatusColors[s] || 'grey'; }

    formatPeriod(run: PayrollRunDto): string {
        const start = this.formatShortDate(run.periodStart);
        const end = this.formatShortDate(run.periodEnd);
        if (!start && !end) return '';
        return `${start} – ${end}`;
    }

    formatShortDate(s: string | null): string {
        if (!s) return '';
        const d = new Date(s);
        return isNaN(d.getTime()) ? '' : d.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
    }

    formatDate(s: string | null): string {
        if (!s) return '';
        const d = new Date(s);
        return isNaN(d.getTime()) ? '' : d.toLocaleString();
    }

    formatPence(p: number): string {
        if (!p) return '£0';
        return '£' + (p / 100).toLocaleString(undefined, { maximumFractionDigits: 0 });
    }

    navigateToRun(id: string) {
        this.$router.push({ name: PageNames.AgencyPayrollRunDetails, params: { payrollRunId: id } });
    }

    formatLongDate(s: string | null): string {
        if (!s) return '';
        const d = new Date(s);
        return isNaN(d.getTime()) ? '' : d.toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
    }

    openNewRunDialog() {
        this.newRunDialog = true;
        // Fire-and-forget — the dialog renders its own loading state while
        // the period resolves from the payroll system.
        this.loadCurrentPeriod();
    }

    loadCurrentPeriod() {
        PayrollRunListModule.fetchCurrentPeriod();
    }

    closeNewRunDialog() {
        this.newRunDialog = false;
    }

    async onConfirmNewRun() {
        if (!this.currentPeriod) return;
        const created = await PayrollRunListModule.createDraft({
            externalPayrollSystemPeriodId: this.currentPeriod.periodId,
        });
        if (created && created.id) {
            this.newRunDialog = false;
            this.navigateToRun(created.id);
        }
    }

    async beforeMount() {
        await PayrollRunListModule.fetch();
    }
}
